import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAssetMeasurementsLookupParamsRawI,
	LWApiPublicAssetMeasurementsLookupResultRawI,
} from '@liquidweb-dev/club-sauce/public/asset/measurements/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ASSET_MEASUREMENTS_LOOKUP_QUERY_KEY = '/asset/measurements/lookup';

const useAssetMeasurementsLookup = (
	params: LWApiPublicAssetMeasurementsLookupParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicAssetMeasurementsLookupResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [ASSET_MEASUREMENTS_LOOKUP_QUERY_KEY, params],
		queryFn: () => api.asset.measurements.apiRaw.lookup(params),
		...options,
	});

export default useAssetMeasurementsLookup;
